import React, {Component, Fragment} from "react";
import './TimeTrackingField.scss'
import Select, {components, OptionProps} from 'react-select'
import classNames from "classnames";
import {connect} from "react-redux";

const groupStyles = {
  backgroundColor: '#EBECF0',
  color: '#172B4D',
  fontSize: 16,
  fontWeight: 'bold',
  lineHeight: '1',
  minWidth: 1,
  padding: '4px',
  textAlign: 'left',
};

const formatGroupLabel = (data) => {
    return (
        <div style={groupStyles}>
            <div> <span>{data.title}</span></div>
            <div> <small>{data.subTitle}</small></div>

        </div>
    );
}

const Option = (props) => {
    return (
        <components.Option {...props} >
            <div> <span>{props.data.title}</span></div>
            <div> <small>{props.data.subTitle}</small></div>
        </components.Option>
    );
};

const SingleValue = ({
                         children,
                         ...props
                     }) => {
    return (
        <components.SingleValue {...props}>
            <div> <span>{props.data.title}</span></div>
            <div> <small>{props.data.subTitle}</small></div>
        </components.SingleValue>
    );
}


const getOptionValue = (option) => {
    return option.value
}


class PbleField extends Component {

  constructor(props) {
    super(props);

    this.state = {
      selected: null,
    }
  }

  componentDidMount() {
    this.setState({
     selected: this.props.value.selected
    }, () => this.onInput())

  }

  onChange(e) {
    this.setState({
        selected: e? e.value: null
    }, () => {
        this.onInput()
    })
  }
  onInput() {
    this.props.onValueChange && this.props.onValueChange(this.props.name, {
      selected: this.state.selected,
      isValid: !!this.state.selected
    });
  }

  get options() {
    return this.props.element.list ? this.props.element.list.map(o => ({
      value: o.id,
      title: o.title,
      subTitle: o.subTitle,
      label: `${o.title} - ${o.subTitle}`
    })): []
  }

  get selected() {
    return this.props.element.list? this.props.element.list.find(o => o.id === this.state.selected): null
  }
  render() {
    const { element = {categories: [], form_title: "Time tracking"}} = this.props;

    const isEdit = this.props.userContext.scope === 'oit' && !element.allowOitToChoosePble? false: this.props.isEdit
    return (
      <div className="time-tracking-field">

        {isEdit ? (
          <Fragment>
            <div className="time-category time-category-title">{element.form_title}</div>
            <Select
              value={this.selected}
              components={{Option, SingleValue}}
              isClearable={true}
              isSearchable={true}
              defaultValue={null}
              options={this.options}
              name={'value'}
              getOptionValue={(o) => getOptionValue(o)}
              formatGroupLabel={formatGroupLabel}
              onChange={(e) => this.onChange(e)}
            ></Select>
              {this.selected? <div style={{padding: '15px 30px'}}
                    dangerouslySetInnerHTML={{__html: this.selected.description}}></div>: null}
              <br/>
              <br/>
          </Fragment>
        ): (
            this.selected? <div style={{padding: '15px 30px'}}>
                <br/>
                <br/>
                <div className="text-center"><b>{this.selected.title}</b></div>
                <div className="text-center"><b>{this.selected.subTitle}</b></div>
                <div className="text-center" dangerouslySetInnerHTML={{__html: this.selected.description}}></div>
                <br/>
                <br/>
            </div>: <div>NO PBLE selected</div>
        )}

      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    userContext: state.common.userContext,
  };
};

export default connect(mapStateToProps)(PbleField)
